// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3b9SF","label":"Completed_label__3DNBj"};